import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'webapp-compat-tasklist',
  template: `
  <div
    *ngIf="projectId"
    id="webapp-tasklist-container">
    <app-tasklist
      id="webapp-tasklist"
      class="WebappCompatTasklist-hide"
      [projectId]="projectId"
      [freelancerView]="freelancerView"
    >
    </app-tasklist>
  </div>
  `,
  styleUrls: ['compat-tasklist.component.scss'],
})
export class CompatTasklistComponent implements OnInit {
  projectId: number;
  freelancerView = false;

  ngOnInit() {
    const w = <any>window;
    if (w && w.webappCompat && w.webappCompat.tasklist) {
      if (w.webappCompat.tasklist.projectId) {
        this.projectId = w.webappCompat.tasklist.projectId;
      }
      if (w.webappCompat.tasklist.viewAsFreelancer) {
        this.freelancerView = true;
      }
      w.webappCompat.tasklist.tasklistLoaded = true;
    }
  }
}
